export const SET_CM_TOPOLOGY_REQUEST = 'SET_CM_TOPOLOGY_REQUEST';
export const SET_CM_TOPOLOGY_SUCCESS = 'SET_CM_TOPOLOGY_SUCCESS';
export const SET_CM_TOPOLOGY_ERROR = 'SET_CM_TOPOLOGY_ERROR';
export const SET_CM_TOPOLOGY_SPECIFIC_PAGE_REQUEST = 'SET_CM_TOPOLOGY_SPECIFIC_PAGE_REQUEST';
export const SET_CM_TOPOLOGY_SPECIFIC_PAGE_SUCCESS = 'SET_CM_TOPOLOGY_SPECIFIC_PAGE_SUCCESS';
export const SET_CM_TOPOLOGY_SPECIFIC_PAGE_ERROR = 'SET_CM_TOPOLOGY_SPECIFIC_PAGE_ERROR';
export const SET_CM_ALL_PRE_VALIDATION_CHECKS_REQUEST = 'SET_CM_ALL_PRE_VALIDATION_CHECKS_REQUEST';
export const SET_CM_ALL_PRE_VALIDATION_CHECKS_SUCCESS = 'SET_CM_ALL_PRE_VALIDATION_CHECKS_SUCCESS';
export const SET_CM_ALL_PRE_VALIDATION_CHECKS_ERROR = 'SET_CM_ALL_PRE_VALIDATION_CHECKS_ERROR';
export const SET_CM_START_EXECUTION_REQUEST = 'SET_CM_START_EXECUTION_REQUEST';
export const SET_CM_START_EXECUTION_SUCCESS = 'SET_CM_START_EXECUTION_SUCCESS';
export const SET_CM_START_EXECUTION_ERROR = 'SET_CM_START_EXECUTION_ERROR';
export const SET_CM_STOP_EXECUTION_SUCCESS = 'SET_CM_STOP_EXECUTION_SUCCESS';
export const SET_CM_STOP_EXECUTION_ERROR = 'SET_CM_STOP_EXECUTION_ERROR';
export const SET_CM_STOP_EXECUTION_REQUEST = 'SET_CM_STOP_EXECUTION_REQUEST';

export const SET_CM_UPLOAD_TOPOLOGY_FILE_REQUEST = 'SET_CM_UPLOAD_TOPOLOGY_FILE_REQUEST';
export const SET_CM_UPLOAD_TOPOLOGY_FILE_SUCCESS = 'SET_CM_UPLOAD_TOPOLOGY_FILE_SUCCESS';
export const SET_CM_UPLOAD_TOPOLOGY_FILE_ERROR = 'SET_CM_UPLOAD_TOPOLOGY_FILE_ERROR';

export const SET_CM_DELETE_TOPOLOGY_DATA_REQUEST = 'SET_CM_DELETE_TOPOLOGY_DATA_REQUEST';
export const SET_CM_DELETE_TOPOLOGY_DATA_SUCCESS = 'SET_CM_DELETE_TOPOLOGY_DATA_SUCCESS';
export const SET_CM_DELETE_TOPOLOGY_DATA_ERROR = 'SET_CM_DELETE_TOPOLOGY_DATA_ERROR';

export const SET_CM_RESOURCES_TO_BE_CREATED_REQUEST = 'SET_CM_RESOURCES_TO_BE_CREATED_REQUEST';
export const SET_CM_RESOURCES_TO_BE_CREATED_SUCCESS = 'SET_CM_RESOURCES_TO_BE_CREATED_SUCCESS';
export const SET_CM_RESOURCES_TO_BE_CREATED_ERROR = 'SET_CM_RESOURCES_TO_BE_CREATED_ERROR';

export const SET_CM_DOWNLOAD_TOPOLOGY_SCHEMA_FILE_REQUEST = 'SET_CM_DOWNLOAD_TOPOLOGY_SCHEMA_FILE_REQUEST';
export const SET_CM_DOWNLOAD_TOPOLOGY_SCHEMA_FILE_SUCCESS = 'SET_CM_DOWNLOAD_TOPOLOGY_SCHEMA_FILE_SUCCESS';
export const SET_CM_DOWNLOAD_TOPOLOGY_SCHEMA_FILE_ERROR = 'SET_CM_DOWNLOAD_TOPOLOGY_SCHEMA_FILE_ERROR';